module.exports = __webpack_public_path__ + "static/media/co-funded-by-the-eu-horizontal.ee1a0cc2.jpg";